<template>
    <div class="PreferenceGroup">
        <CHeading variant="2">Preferencie</CHeading>

        <div v-if="preferences">
            <CCardBox>
                <CFormGroup v-if="preferences.intensityValue" label="Časová kapacita">
                    {{ preferences.intensityValue }}
                    {{ getLabelFromId(preferences.intensityUnit, intensityUnits) }}
                </CFormGroup>

                <CFormGroup v-if="preferences.helpHow" label="Ako chcem pomáhať">
                    {{ getLabelFromId(preferences.helpHow, helpHow) }}
                </CFormGroup>

                <CFormGroup v-if="preferences.helpWho" label="Komu chcem pomáhať">
                    <CList>
                        <li v-for="item in preferences.helpWho" :key="item">
                            {{ getLabelFromId(item, helpWho) }}
                        </li>
                    </CList>
                </CFormGroup>

                <CFormGroup v-if="preferences.timeCapacity" label="Ako dlho môžem na projekte spolupracovať">
                    <CList>
                        <li v-for="item in preferences.timeCapacity" :key="item">
                            {{ getLabelFromId(item, capacity) }}
                        </li>
                    </CList>
                </CFormGroup>

                <CFormGroup v-if="preferences.cooperation" label="Ako chcem spolupracovať">
                    <CList>
                        <li v-for="cooperation in preferences.cooperation" :key="cooperation">
                            {{ getLabelFromId(cooperation, cooperationType) }}
                        </li>
                    </CList>
                </CFormGroup>

                <CFormGroup v-if="preferences.volunteerGeoRegion?.length > 0" label="Osobné stretnutia">
                    <CList>
                        <li v-for="region in preferences.volunteerGeoRegion" :key="region">{{ region }} kraj</li>
                    </CList>
                </CFormGroup>
            </CCardBox>
        </div>

        <div v-else>Dobrovoľník nemá žiadne preferencie</div>
    </div>
</template>

<script setup lang="ts">
import { intensityUnits } from '#shared/types/Project'
import type { VolunteerProfile } from '#shared/types/User'
import { capacity, cooperationType, helpHow, helpWho } from '#shared/types/VolunteerOptions'

// Props
const props = defineProps<{
    preferences: VolunteerProfile
}>()

// Methods
function getLabelFromId(itemId: string, array: any[]): string {
    return array.find(({ id }) => itemId === id)?.label || ''
}
</script>